import { Stack } from '@mui/material'
import { useScreeningQuestionnaireStore } from '../../state/store'
import { DynamicScreeningComponents } from './DynamicScreeningComponents'
import { ScreeningOptionsProps } from './types'
import { useTranslation } from 'react-i18next'

export const DynamicScreeningOptions = ({
  type,
  questionId,
  options,
  metadata,
  title,
  description,
  showValidation,
}: ScreeningOptionsProps) => {
  const { t } = useTranslation()
  const { currentQuestion, updateCurrentAnswer } = useScreeningQuestionnaireStore()

  const answer = currentQuestion?.id === questionId ? currentQuestion?.answer || [] : []
  const component = DynamicScreeningComponents[type]

  const descriptionText =
    metadata?.previousScreeningAnswer !== null && metadata?.previousScreeningAnswer !== undefined && metadata?.scale
      ? {
          text: t('employee.screening.previousRating', {
            rating: metadata.previousScreeningAnswer,
            max: metadata.scale.max,
          }),
        }
      : description

  if (!component) {
    return null
  }
  return (
    <Stack gap={3}>
      {component({
        questionId,
        options,
        metadata,
        answer,
        setAnswer: updateCurrentAnswer,
        currentQuestion: currentQuestion || undefined,
        title,
        description: descriptionText,
        showValidation,
      })}
    </Stack>
  )
}
